module.exports = "<div layout=\"column\"><div class=\"counter-holder\"><div class=\"counter\" ng-class=\"{ 'hot': countHot }\">{{ count }}</div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/modules/cart/views/popupBagDirective.pug
// module id = 787
// module chunks = 0